import { inject, provide, ref } from 'vue';
import { getJobConfigById } from '../api/insightsApi';
import { FlowConfigIdType } from '../types/otsConfig';

export interface OtsJobConfig {
  flowConfigId?: FlowConfigIdType | undefined;
  jobId?: string | undefined;
  [key: string]: string | undefined;
}

interface UseOtsJobConfig {
  getOtsJobConfig: () => Promise<OtsJobConfig | undefined>;
  setOtsJobConfig: (flowConfigId: string, jobId: string) => void;
}

const LS_JOB_ID_KEY = 'jobId';
const LS_FLOW_ID_KEY = 'otsFlowConfigId';
const otsJobConfig = ref<OtsJobConfig | undefined>(undefined);

const setOtsJobConfig = (flowConfigId: FlowConfigIdType, jobId: string) => {
  otsJobConfig.value = {
    flowConfigId,
    jobId,
  };
  localStorage.setItem(LS_JOB_ID_KEY, jobId);
  localStorage.setItem(LS_FLOW_ID_KEY, flowConfigId);
};

const getOtsJobConfig = async (): Promise<OtsJobConfig | undefined> => {
  if (otsJobConfig.value) {
    return otsJobConfig.value;
  }

  const storedJobId = localStorage.getItem(LS_JOB_ID_KEY);
  const storedFlowId = localStorage.getItem(LS_FLOW_ID_KEY) as FlowConfigIdType;
  if (storedJobId && storedFlowId) {
    otsJobConfig.value = {
      flowConfigId: storedFlowId,
      jobId: storedJobId,
    };
    return otsJobConfig.value;
  }

  if (storedJobId) {
    const jobConfig = await getJobConfigById(storedJobId);
    otsJobConfig.value = {
      flowConfigId: jobConfig.flowConfigId,
      jobId: storedJobId,
    };

    return otsJobConfig.value;
  }

  return undefined;
};

export const useOtsJobService = () => {
  provide('setOtsJobConfig', setOtsJobConfig);
  provide('getOtsJobConfig', getOtsJobConfig);
};

export const useOtsJob = (): UseOtsJobConfig => ({
  setOtsJobConfig: inject('setOtsJobConfig')!,
  getOtsJobConfig: inject('getOtsJobConfig')!,
});
